import Loading from 'vue-loading-overlay';
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect'

import { mapGetters, mapMutations } from 'vuex';

import { orderService } from '../../services/OrderService';
import { listService } from '../../services/ListService';
import { userService } from '../../services/UserService';
import { attachmentService } from '../../services/AttachmentService';

import SearchBox from '../../views/Controls/SearchBox';
import EmptyListImages from '../../views/Controls/EmptyListImages';

import FinishOrder from './finishOrderComponent.vue';
import CancelOrder from './cancelOrderComponent.vue';
import EditPaymentComponent from './editPaymentComponent.vue';
//
import OfferComponent from './offerComponent.vue';
// Widgets
import OrdersTotals from './../Widgets/OrdersTotals'

export default {
    name: 'OrderList',
    components: {
        EditPaymentComponent,
        EmptyListImages,
        Datepicker,
        Multiselect,
        Loading,
        SearchBox,
        CancelOrder,
        FinishOrder,
        OrdersTotals
    },
    props: {
        caption: {
            type: String,
            default: 'Comenzi'
        },
    },
    data: () => {
        return {
            loading: true,
            loadingOrders: false,

            sortDesc: true,
            sortBy: 'CreatedOn',

            currentPage: 1,
            perPage: 10,
            perPageOptions: [
                { text: '10', value: '10' },
                { text: '20', value: '20' },
                { text: '50', value: '50' },
                { text: '100', value: '100' },
            ],
            formTitle: '',
            focusedRowObject: null,
            selectedRowClass: 'secondary',
            fields: [],
            searchFilter: '',

            totalRows: 0,
            firstRowOnPage: 0,
            lastRowOnPage: 0,

            itemToBeChanged: {},

            // Filled on created()
            propertyTypes: [],
            users: [],

            // stores selected item from mutiselect
            selectedOrderType: {},
            selectedOrderSubType: {},
            selectedOrderStatus: [],
            selectedUser: {},

            searchOrderParams:
            {
                EndDate: new Date(),
                StartDate: new Date(),
                OrderType: 0,
                OrderSubType: 0,
                Status: [],
                InsuranceCompanies: [],
                UserId: '',
                FilterType: 1,
                IsSiteOrder: false,
            },

            orderSubTypeOptions: [
                { id: 1, name: 'PAD' },
                { id: 2, name: 'Facultativ' },
            ],

            searchOptions: [
                { value: 0, name: 'Comenzi in lucru' }, /*CurrentOrders = 0,*/
                { value: 1, name: 'Filtreaza' },        /*CustomFilter = 1,*/
            ],

            showNoDocumentAlert: false,
            refreshOnCloseDropdownForm: false,

            finishDetails: null,
            paymentDetails: null,
            searchDefault: {
                Text: 'CNP/CUI',
                Value: 'UniqueId'
            }
        }
    },
    computed: {
        ...mapGetters(
            {
                // general
                userProfile: 'user/profile',
                userHasRole: 'user/hasRole',
                orderTypeSettings: 'general/orderTypeSettings',
                appSettings: 'general/appSettings',
                settingsLoaded: 'general/settingsLoaded',
                typeSettings: 'general/typeSettings',
            }),

        //#region enums

        orderTypes() {
            // return only active and user defined types
            var listOfOrderTypes = Object.values(this.orderTypeSettings);
            return listOfOrderTypes.filter(function (el) {
                return el.IsActive == true;
            });
        },

        orderStatusList() {
            return orderService.getOrderStatusList();
        },

        requestStatusList() {
            return orderService.getrequestStatusList();
        },

        orderStatus() {
            return orderService.orderStatus;
        },

        requestStatus() {
            return orderService.requestStatus;
        },

        roles() {
            return userService.roles;
        },
        //#endregion 

        canHandleOrders() {
            return this.userHasRole(this.roles.admin) || this.userHasRole(this.roles.operator);
        },

        cancelDetails() {
            if (this.itemToBeChanged != null)
                return this.itemToBeChanged.Detail1 + ' ' + this.itemToBeChanged.Detail2;
        },

    },
    created() {
        if (this.$route.params.filter != null) {

            this.searchOrderParams = this.$route.params.filter;

            this.selectedOrderType = this.orderTypes.find(item => item.Id == this.searchOrderParams.OrderType);

            // preselect from filter
            this.searchOrderParams.Status.forEach(element => {
                this.selectedOrderStatus.push(this.orderStatusList.find(item => item.Value == element))
            })

            //this.selectedOrderStatus = this.orderStatusList.find(item => item.Value == this.searchOrderParams.Status);
            this.selectedUser = this.users.find(item => item.Id == this.searchOrderParams.UserId);

        }
        else {
            //set default filter

            if (this.$route.name === 'ConfirmedOrderList') {

            }
            else if (this.$route.name === 'OnlineConfirmedOrderList') {
                this.searchOrderParams.IsSiteOrder = true;
            }

            this.searchOrderParams.EndDate = new Date();
            this.searchOrderParams.StartDate = new Date();
            //this.clearFilters();
        }

        // make sure the settings are loaded
        this.$store.dispatch('general/getSettings');
        this.$store.dispatch('general/getOrderTypeSettings');

        // clear order
        this.clearOrder();

        //get property types
        this.propertyTypes = listService.getPropertyTypes();

        // get users
        var model = this;
        userService.getUsers().then((response) => {
            model.users = response.data;
            model.loading = false;
        });

        //create columns
        this.fields = [
            { key: 'Type', label: 'Tip', sortable: true, thStyle: 'width:10%' },
            { key: 'OwnerName', label: 'Asigurat', sortable: true },
            { key: 'Detail1', label: 'Bun asigurat', sortable: true, thStyle: 'width:15%' },
            { key: 'Insurer', label: 'Valabilitate', sortable: true, thStyle: 'width:15%' },
            { key: 'RequestDate', label: 'Data comanda', sortable: true, thStyle: 'width:15%' },
            { key: 'Policy', label: 'Polita', sortable: false, thStyle: 'width:15%' },
            { key: 'Id', label: '', thStyle: 'min-width:100px' }
        ];
    },

    methods: {
        ...mapMutations(
            {
                clearOrder: 'order/clear',
            }),

        //#region search and refresh
        clearFilters() {
            this.searchOrderParams.EndDate = null;//new Date();
            this.searchOrderParams.StartDate = null;//new Date();
            this.searchOrderParams.OrderType = 0;
            this.searchOrderParams.OrderSubType = 0;
            this.searchOrderParams.InsuranceCompanies = [];
            this.searchOrderParams.selectedUser = '';

            this.selectedOrderType = null;
            this.selectedUser = null;
            this.selectedOrderStatus = null;
        },

        clearSearchButtonClick() {
            // clear filters
            this.clearFilters();

            // close dropdown
            this.refreshOnCloseDropdownForm = true;
            //this.$refs.dropdown.hide(true);
        },

        closeSearchButtonClick() {
            // close dropdown
            this.refreshOnCloseDropdownForm = false;
            this.$refs.dropdown.hide(true);
        },

        dropdownShown() {
            // TO DO:
        },

        hideDropdown(bvEvt) {
            // refresh data
            if (this.refreshOnCloseDropdownForm) {
                this.$refs.ordersTable.refresh();
                //this.$refs.ordersTotal.refresh();
            }
        },

        refreshButtonClick() {
            // refresh data
            this.$refs.ordersTable.refresh();
            //this.$refs.ordersTotal.refresh();
        },

        refreshTable: function (searchText) {
            console.log('searchTextChanged - searchFilter =' + searchText);
            this.searchFilter = searchText;
            this.$refs.ordersTable.refresh();
            //this.$refs.ordersTotal.refresh();
        },

        searchButtonClick() {
            this.refreshOnCloseDropdownForm = true;
            this.$refs.dropdown.hide(true);
        },

        searchTextChanged: function (searchText) {



            console.log('searchTextChanged - searchFilter =' + searchText);

            if (searchText != '') {
                this.clearFilters();
                this.searchOrderParams.FilterType = 1; // seach in al database
            }
            // refresh if not refershing
            if (!this.loadingOrders) {
                this.refreshTable(searchText);
            }

        },

        selectedFilterOptionChanged(value) {
            if (value == 0) { //comenzi in lucru
                //debugger
                // close dropdown
                this.refreshOnCloseDropdownForm = false;
                this.canCloseDropdownForm = true;
                this.$refs.dropdown.hide(true);

                // clear filters
                this.clearFilters();
                this.$refs.searchBox.clear();

                //// refresh data
                this.$refs.ordersTable.refresh();
                //this.$refs.ordersTotal.refresh();
            }
            else if (value == 1) { // filtre
                this.searchOrderParams.EndDate = null;
                this.searchOrderParams.StartDate = null;
            }
        },

        orderType_changed(value) {
            this.selectedOrderType = value;

            this.searchOrderParams.OrderType = value.Id;
            if (this.selectedOrderType.JsonSettings.PropertyType != 0) {
                this.searchOrderParams.OrderSubType = 0;
            }
        },
        orderType_removed(value, id) {
            this.selectedOrderType = value;
            this.searchOrderParams.OrderType = 0; // All
            this.searchOrderParams.OrderSubType = 0;
        },
        orderSubType_changed(value) {
            this.selectedOrderSubType = value;
            this.searchOrderParams.OrderSubType = value.id;
        },
        orderSubType_removed(value, id) {
            this.selectedOrderSubType = value;
            this.searchOrderParams.OrderSubType = 0; // All
        },

        user_changed(value) {
            this.selectedUser = value;
            this.searchOrderParams.UserId = value.Id;
        },
        user_removed(value, id) {
            this.selectedUser = value;
            this.searchOrderParams.UserId = '';
        },

        status_changed(item) {
            //debugger
            //this.selectedOrderStatus.push(item)
            this.searchOrderParams.Status.push(item.Value);
        },
        status_removed(item) {
            //debugger
            //this.selectedOrderStatus = this.selectedOrderStatus.filter(x => x.Value != item.Value);
            this.searchOrderParams.Status = this.searchOrderParams.Status.filter(x => x != item.Value);
        },

        //#endregion

        //#region call service to get data
        ordersDataProvider(ctx) {
            var self = this;
            self.loadingOrders = true;

            var params = {
                SortDesc: ctx.sortDesc,
                ShowAll: false,
                CurrentPage: ctx.currentPage,
                PerPage: ctx.perPage,
                SortBy: ctx.sortBy,
                SearchFilterObject: JSON.stringify(this.searchOrderParams),
                SearchFilter: this.searchFilter,
            };

            // get the page from server
            return orderService.getOrdersPage(params)
                .then(response => {
                    self.totalRows = response.data.RowCount;
                    self.firstRowOnPage = response.data.FirstRowOnPage;
                    self.lastRowOnPage = response.data.LastRowOnPage;

                    const items = response.data.Results || [];
                    self.loadingOrders = false;

                    // refresh totals
                    self.$refs.ordersTotal.refresh();

                    return (items);
                })
                .catch(e => {
                    showErrorNotification(e);
                    self.loadingOrders = false;
                    return [];
                });
        },
        //#endregion

        //#region Permisions
        canStartOrder(data) {
            //
            return (data.item.Status === this.orderStatus.confirmed || data.item.Status === this.orderStatus.policy || data.item.Status === this.orderStatus.blocked)
                && data.item.RequestStatus == this.requestStatus.new
                && this.canHandleOrders;
        },

        canFinishOrder(data) {
            return (data.item.Status === this.orderStatus.confirmed || data.item.Status === this.orderStatus.blocked)
                && (data.item.RequestStatus === this.requestStatus.inProgress)
                && this.canHandleOrders;
        },

        canFinishPayment(data) {
            return (data.item.RequestType == 1 && data.item.RequestStatus === this.requestStatus.inProgress && this.canHandleOrders);
        },

        //#endregion

        //#region button events
        cancelButtonClick(item) {
            var orderParam = {};
            // if is vehicle order get the params
            if (this.isVehicleOrder(item.TypeId)) {
                orderParam.Id = item.Id;
                orderParam.AddToBlackList = this.$refs.cancelOrder.addToBlackList;
                orderParam.BlackListText = this.$refs.cancelOrder.blackListText;
                orderParam.RowVersion = item.RowVersion;
            }
            else {
                orderParam.Id = item.Id;
                orderParam.AddToBlackList = false;
                orderParam.BlackListText = '';
                orderParam.RowVersion = item.RowVersion;
            }

            var model = this;
            orderService.cancelOrder(orderParam).then(() => {
                item.Status = model.orderStatus.canceled;
                item.RequestStatus = model.requestStatus.done;
            })
        },

        isVehicleOrder(orderType) {
            var orderSettings = this.typeSettings(orderType);
            return orderSettings.JsonSettings.PropertyType == 1;
        },

        deleteButtonClick(dataItem) {
            if (dataItem != null) {
                var model = this;

                orderService.deleteOrder(dataItem.Id, dataItem.RowVersion)
                    .then(response => {
                        model.$refs.ordersTable.refresh();
                        // model.$refs.ordersTotal.refresh();
                    })
            }
        },

        editButtonClick(data) {
            if (data != null) {
                if (this.$route.name === 'ConfirmedOrderList'
                    || this.$route.name === 'OnlineConfirmedOrderList') {
                    var redirectPath = '/crm/order/edit/' + data.item.Id;
                }
                else {
                    var redirectPath = '/crm/offer/edit/' + data.item.Id;
                }
                this.$router.push({ path: redirectPath });
            }
        },

        viewButtonClick(data) {
            if (data != null) {
                if (this.$route.name === 'ConfirmedOrderList'
                    || this.$route.name === 'OnlineConfirmedOrderList') {
                    var redirectPath = '/crm/order/view/' + data.item.Id;
                }
                else {
                    var redirectPath = '/crm/offer/view/' + data.item.Id;
                }
                this.$router.push({ path: redirectPath });
            }
        },

        updateOfferButtonClick() {
            // Prevent modal from closing
            bvModalEvt.preventDefault();

            // Trigger submit handler
            if (!this.$refs.editOfferModal.validate())
                return;

            this.$refs.editOfferModal.saveOffer(); // => triggers change of the model paymentDetails (which is watched below)
        },

        editOfferButtonClick: function (data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['editOfferModal'].show();
            }
        },

        finishButtonClick(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()

            // Trigger submit handler
            if (!this.$refs.finishOrderComponent.validate())
                return;

            this.$refs.finishOrderComponent.finishOrder(); // => triggers change of the model finishDetails (which is watched below)
        },

        getPdfOfferButtonClick: function (data) {
            window.location.href = 'api/Order/Pdf/' + data.item.Id;
        },

        payButtonClick(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();

            // Trigger submit handler
            if (!this.$refs.editPaymentComponent.validate())
                return;

            this.$refs.editPaymentComponent.savePayment(); // => triggers change of the model paymentDetails (which is watched below)
        },

        startButtonClick(data) {
            var order = {
                Id: data.item.Id,
                RowVersion: data.item.RowVersion,
                // set status in progress
                RequestStatus: this.requestStatus.inProgress,
            }

            var model = this;
            orderService.changeStatus(order).then(() => {
                data.item.RequestStatus = model.requestStatus.inProgress;
                data.item.Operator = this.userProfile.UserName;
            })
        },

        finishOrderButtonClick(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['modalFinish'].show();
            }
        },

        finishPaymentButtonClick(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['modalPayment'].show();
            }
        },

        cancelOrderButtonClick(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['modalCancel'].show();
            }
        },

        deleteOrderButtonClick(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['modalDelete'].show()
            }
        },

        showOrderDetails(data) {
            debugger
            this.$bvModal.msgBoxOk(data.Remarks, {
                title: 'Comanda ' + data.Id,
                okVariant: 'primary',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
            });
        },

        //#endregion

        //#region UI util methods
        getAuditInfoHtml(data) {
            var html = '<div class="small text-muted">Adaugat:&nbsp;<b>' + data.item.CreatedBy + '&nbsp;la&nbsp; ' + this.formatDateTime(data.item.CreatedOn) + '</b></div>';//(' + data.item.RelativeCreatedOn + ')</div >';
            if (data.item.UpdatedBy != null) {
                html += '<div class="small text-muted">Modificat:&nbsp;<b>' + data.item.UpdatedBy + '&nbsp;la&nbsp; ' + this.formatDateTime(data.item.UpdatedOn) + '</b></div>';//(' + data.item.RelativeUpdateddOn + ')</div >';
            }
            if (data.item.Operator != null) {
                html += '<hr/> <div class="small text-muted">Preluat de:&nbsp;<b>' + data.item.Operator + '&nbsp;la&nbsp; ' + data.item.ProcessStart + '</b></div>';//(' + data.item.RelativeUpdateddOn + ')</div >';

                if (data.item.RequestStatus > this.requestStatus.inProgress) {
                    html += '<div class="small text-muted">Finalizat de:&nbsp;<b>' + data.item.Operator + '&nbsp;la&nbsp; ' + data.item.ProcessEnd + '</b></div>';//(' + data.item.RelativeUpdateddOn + ')</div >';
                }
            }


            return html;
        },

        getProcessUserToolTip(data) {
            if (data.item.Operator != null) {
                return 'Preluat ' + data.item.RelativeProcessStart
            }
        },

        getStatusVariant(item) {
            var badgeVariant = 'primary';
            switch (item.Status) {
                case 0, 1, 2: // draft/request/Confirmed = 2, // offer accepted
                    badgeVariant = 'danger';
                    if (item.RequestStatus == this.requestStatus.inProgress) {
                        badgeVariant = 'warning';
                    }
                    break;
                case 4: //Policy = 4, // Policy issued
                    badgeVariant = 'success';
                    break;
                case 5: //Canceled = 5, // policy canceled
                    badgeVariant = 'secondary';
                    break;
                case 6: //Blocked = 5, // policy canceled
                    badgeVariant = 'dark';
                    break;
                default:
            }
            return badgeVariant;
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.Status === 5) return 'table-danger' //Canceled = 5, // policy canceled
        },

        getPaymentsTotal: function (item) {
            if (item.Payments.length == 0) {
                return 0;
            }
            else {
                let sum = item.Payments.map(o => o.PaidAmount).reduce((a, c) => { return a + c });
                return sum;
            }
        },

        getStatusText(item) {
            var badgeText = 'Oferta';

            switch (item.RequestStatus) {
                case 0: // new
                    {
                        if (item.IsSiteOrder) {
                            switch (item.Status) {
                                case 1: //Request = 1
                                    badgeText = 'Comanda nefinalizata';
                                    break;
                                case 2: //Confirmed = 2 
                                    badgeText = 'Cerere';
                                    break;
                                default:
                            }
                        }
                        else {
                            badgeText = 'Cerere';
                        }
                        break;
                    }
                case 1: //in progress
                    badgeText = 'Preluata de ' + item.Operator;
                    break;
                case 2: // Done

                    switch (item.Status) {
                        case 4: //Policy = 4, // Policy issued
                            badgeText = 'Polita emisa';
                            break;
                        case 5: //Canceled = 5, // policy canceled
                            badgeText = 'Anulata';
                            break;
                        case 6: //Blocked = 5, // policy canceled
                            badgeText = 'Blocata';
                            break;
                        default:
                    }

                    break;

                default:
            }

            return badgeText;
        },

        zeroPad(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        },
        //#endregion

        //#region Download
        downloadPolicy: function (item) {
            var uploadParams = {
                targetType: 0,
                targetId: item.Id
            };
            attachmentService.getAllAttachments(uploadParams).then((response) => {
                var attachments = response.data;
                if (attachments && attachments.length > 0) {
                    if (attachments[0].url)
                        window.location.href = attachments[0].url;
                    else {
                        window.location.href = window.location.origin + '/api/Attachment/Download/' + attachments[0].id;
                    }
                }
                else {
                    this.showNoDocumentMessage('Download polita');
                }
            });
        },

        downloadPaymentReceipt: function (item) {
            var uploadParams = {
                targetType: 1,
                targetId: item.Id
            };
            attachmentService.getAllAttachments(uploadParams).then((response) => {
                var attachments = response.data;

                if (attachments && attachments.length > 0) {
                    if (attachments[0].url)
                        window.location.href = attachments[0].url;
                    else
                        window.location.href = window.location.origin + '/api/Attachment/Download/' + attachments[0].id;
                }
                else {
                    this.showNoDocumentMessage('Download chitanta');
                }
            })
        },

        showNoDocumentMessage: function (title) {
            this.boxTwo = ''
            this.$bvModal.msgBoxOk('Nu a fost gasit nici un document atasat.', {
                title: title,
                okVariant: 'success',
                buttonSize: 'lg',
                headerClass: 'p-2 border-bottom-1',
                footerClass: 'p-2 border-top-0 mx-auto',

                centered: true
            })
                .then(value => {
                    this.boxTwo = value
                })
                .catch(err => {
                    // An error occurred
                })
        },
        //#endregion

        // payment
        getNextPayment(currentOrder) {
            if (currentOrder != null && currentOrder.Payments != null) {
                return currentOrder.Payments.find(p => !p.Paid);
            }
            else {
                return null;
            }

        }
    },

    watch: {

        finishDetails: {
            handler: function () {
                if (this.finishDetails.orderFinalized || this.finishDetails.uploadFinalized) {
                    // Hide the modal manually
                    this.$nextTick(() => {
                        this.$refs.modalFinish.hide();
                    });

                    // Refresh table
                    this.$refs.ordersTable.refresh();
                    //this.$refs.ordersTotal.refresh();
                }
            },
            deep: true
        },
        paymentDetails: {
            handler: function () {
                if (this.paymentDetails.paymentFinalized || this.paymentDetails.uploadFinalized) {
                    // Hide the modal manually
                    this.$nextTick(() => {
                        this.$refs.modalPayment.hide();
                    });

                    // Refresh table
                    this.$refs.ordersTable.refresh();
                    //this.$refs.ordersTotal.refresh();
                }
            },
            deep: true
        }
    }
}
